<div class="wallet-loading" *ngIf="cargando">
	<i class="fas fa-circle-notch fa-spin"></i>
	<span>Cargando billetera...</span>
</div>

<div class="wallet-alert wallet-alert-danger" *ngIf="!cargando && error">
	<i class="fas fa-exclamation-circle"></i>
	<span>{{ error }}</span>
	<button type="button" (click)="cargar()">Reintentar</button>
</div>

<ng-container *ngIf="!cargando && !error">
	<div class="wallet-summary">
		<div class="wallet-card wallet-card-primary">
			<div class="wallet-card-icon"><i class="fas fa-wallet"></i></div>
			<div>
				<span>Saldo disponible</span>
				<strong>{{ resumen.saldoDisponible | currency : "CLP" : "symbol-narrow" : "1.0-0" }}</strong>
				<small>Disponible para tus compras en todas tus empresas</small>
			</div>
		</div>

		<div class="wallet-card">
			<span>Saldo contable</span>
			<strong>{{ resumen.saldoContable | currency : "CLP" : "symbol-narrow" : "1.0-0" }}</strong>
			<small>Total confirmado en tu billetera</small>
		</div>

		<div class="wallet-card">
			<span>Temporalmente reservado</span>
			<strong>{{ resumen.saldoReservado | currency : "CLP" : "symbol-narrow" : "1.0-0" }}</strong>
			<small>Compras pendientes de confirmación</small>
		</div>
	</div>

	<div class="wallet-history">
		<div class="wallet-history-header">
			<div>
				<h2>Movimientos</h2>
				<p>Solo se muestran abonos y cargos confirmados.</p>
			</div>
			<button type="button" class="wallet-refresh" [disabled]="cargando || cargandoMovimientos" (click)="refrescar()">
				<i class="fas fa-sync-alt"></i>
				Actualizar
			</button>
		</div>

		<div class="wallet-loading wallet-loading-history" *ngIf="cargandoMovimientos">
			<i class="fas fa-circle-notch fa-spin"></i>
			<span>Cargando movimientos...</span>
		</div>

		<div class="wallet-alert wallet-alert-danger" *ngIf="!cargandoMovimientos && errorMovimientos">
			<i class="fas fa-exclamation-circle"></i>
			<span>{{ errorMovimientos }}</span>
			<button type="button" (click)="cargar(pagina)">Reintentar</button>
		</div>

		<div class="wallet-empty" *ngIf="!cargandoMovimientos && !errorMovimientos && movimientos.length === 0">
			<i class="fas fa-receipt"></i>
			<strong>Aún no tienes movimientos confirmados</strong>
			<span>Cuando recibas o utilices saldo, aparecerá en este historial.</span>
		</div>

		<div class="wallet-table-wrap" *ngIf="!cargandoMovimientos && !errorMovimientos && movimientos.length > 0">
			<table class="wallet-table">
				<thead>
					<tr>
						<th>Fecha</th>
						<th>Movimiento</th>
						<th>Detalle</th>
						<th>Empresa</th>
						<th class="wallet-amount">Monto</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let movimiento of movimientos; trackBy: trackMovimiento">
						<td>{{ movimiento.fechaMovimiento | date : "dd/MM/yyyy HH:mm" }}</td>
						<td>{{ etiquetaMovimiento(movimiento) }}</td>
						<td>{{ detalleMovimiento(movimiento) }}</td>
						<td class="wallet-company">
							<ng-container *ngIf="movimiento.empresaRazonSocial; else empresaNoDisponible">
								<span>{{ movimiento.empresaRazonSocial }}</span>
								<small *ngIf="movimiento.empresaRut">{{ movimiento.empresaRut }}</small>
							</ng-container>
							<ng-template #empresaNoDisponible>—</ng-template>
						</td>
						<td class="wallet-amount"
							[class.wallet-positive]="movimiento.montoConSigno > 0"
							[class.wallet-negative]="movimiento.montoConSigno < 0">
							{{ movimiento.montoConSigno > 0 ? "+" : "" }}{{ movimiento.montoConSigno | currency : "CLP" : "symbol-narrow" : "1.0-0" }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="wallet-pagination" *ngIf="totalMovimientos > tamanoPagina">
			<button type="button" [disabled]="pagina <= 1 || cargandoMovimientos" (click)="cargar(pagina - 1)">
				<i class="fas fa-chevron-left"></i>
				Anterior
			</button>
			<span>Página {{ pagina }} de {{ totalPaginas }}</span>
			<button type="button" [disabled]="pagina >= totalPaginas || cargandoMovimientos" (click)="cargar(pagina + 1)">
				Siguiente
				<i class="fas fa-chevron-right"></i>
			</button>
		</div>
	</div>
</ng-container>
